import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from '../services/api/api.service';
import { Store } from '@ngrx/store';
import { AppState } from '../@store/reducers';
import { ProfileSelectors } from '../@store/selectors/profile.selectors';
import { ProfileActions } from '../@store/actions/profile.actions';

@Injectable({
  providedIn: 'root',
})
export class SetPasswordGuard {
  requiredChangePassword$ = this.store.select(ProfileSelectors.getRequiredChangePassword);

  constructor(
    private api: ApiService,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.api.get('/manage/accounts/v3/check-password-change-needed').pipe(
      map((requiredChangePassword: boolean) => {
        this.store.dispatch(
          ProfileActions.SetRequiredChangePassword({ value: requiredChangePassword }),
        );

        if (requiredChangePassword) {
          if (state.url.includes('/account/set-password')) {
            document.body.classList.add('required-change-password');
            return true;
          }
          return this.router.createUrlTree(['/account', 'set-password']);
        } else {
          document.body.classList.remove('required-change-password');
          return true;
        }
      }),
      catchError(() => {
        this.store.dispatch(ProfileActions.SetRequiredChangePassword({ value: false }));
        return of(true);
      }),
    );
  }
}
